export interface ISpecialty {
  EdapySpecialtyID?: string;
  IsActive?: boolean
  SpecialtyAlias?: string;
  SpecialtyID?: number
  SpecialtyName?: string;
}

export class Specialty implements ISpecialty {
  EdapySpecialtyID?: string;
  IsActive?: boolean
  SpecialtyAlias?: string;
  SpecialtyID?: number
  SpecialtyName?: string;

  constructor();
  constructor(obj: ISpecialty);
  constructor(obj?: ISpecialty) {

  }
}
